// todo will use values from graph instead
import type { useApplicationVolumeJdpFeatureFlag } from 'src/store/featureFlags/hooks';
const LOW_APPLICATIONS_THRESHOLD = 20;
const HIGH_APPLICATIONS_THRESHOLD = 150;
export const useNumberOfApplicants = ({
  numberOfApplicants,
  flag,
}: {
  numberOfApplicants: number;
  flag: ReturnType<typeof useApplicationVolumeJdpFeatureFlag>;
}) => {
  switch (flag) {
    case 'control':
      return undefined;

    case 'volume':
      if (numberOfApplicants < LOW_APPLICATIONS_THRESHOLD) {
        return 'Low application volume';
      }
      if (numberOfApplicants > HIGH_APPLICATIONS_THRESHOLD) {
        return 'High application volume';
      }
      return 'Medium application volume';

    case 'count':
      if (numberOfApplicants < LOW_APPLICATIONS_THRESHOLD) {
        return `Less than ${LOW_APPLICATIONS_THRESHOLD} applicants`;
      }
      if (numberOfApplicants > HIGH_APPLICATIONS_THRESHOLD) {
        return `More than ${HIGH_APPLICATIONS_THRESHOLD} applicants`;
      }
      return `${numberOfApplicants} applicants`;

    default:
      return undefined;
  }
};
